import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

/**
 * Warns the CANDIDATE (own dashboard) when one or more documents are about
 * to expire (≤ 60 days). Renders nothing when everything is up to date.
 */
export default function ExpiringDocsBanner() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/candidates/documents/expiring")
            .then((r) => setItems(r.data || []))
            .catch(() => setItems([]));
    }, []);
    if (items.length === 0) return null;
    const critical = items.filter((d) => d.days_left <= 7).length;
    return (
        <section
            className={`rounded-2xl p-4 mb-6 border-l-4 flex items-start gap-3 ${
                critical > 0 ? "border-red-500 bg-red-50" : "border-amber-500 bg-amber-50"
            }`}
            data-testid="expiring-docs-banner"
        >
            <AlertTriangle
                size={22}
                className={critical > 0 ? "text-red-600" : "text-amber-600"}
            />
            <div className="flex-1 min-w-0">
                <div className={`font-semibold text-sm ${critical > 0 ? "text-red-800" : "text-amber-800"}`}>
                    {critical > 0
                        ? `${critical} document${critical > 1 ? "s" : ""} arrive${critical > 1 ? "nt" : ""} à expiration dans moins de 7 jours`
                        : `${items.length} document${items.length > 1 ? "s" : ""} arrive${items.length > 1 ? "nt" : ""} à expiration sous 60 jours`}
                </div>
                <ul className="text-xs mt-1 space-y-0.5 text-slate-700">
                    {items.slice(0, 4).map((d) => (
                        <li key={d.id}>
                            • <b>{d.label || d.doc_type}</b> — expire le {d.valid_until}
                            {" "}({d.days_left <= 0
                                ? "expiré"
                                : `${d.days_left} jour${d.days_left > 1 ? "s" : ""} restant${d.days_left > 1 ? "s" : ""}`})
                        </li>
                    ))}
                </ul>
                <div className="text-[11px] text-slate-500 mt-2">
                    Rendez-vous dans <b>Mes documents</b> pour téléverser la version à jour.
                </div>
            </div>
        </section>
    );
}
